<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5>
          Tipo: <span class="tipo_title">{{ state.tipo }}</span>
        </h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <label for="nome">Nome</label>
            <p>{{ state.nome }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Email</label>
            <p>{{ state.email }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Razão Social</label>
            <p>{{ state.razao_social }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Telefone</label>
            <p>{{ state.telefone }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Whatsapp</label>
            <p>{{ state.whatsapp }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Cidade</label>
            <p>{{ state.cidade }}</p>
          </div>
          <div class="col-md-3">
            <label for="nome">Estado</label>
            <p>{{ state.estado }}</p>
          </div>
          <div class="col-md-12">
            <label for="nome">Mensagem</label>
            <p>{{ state.mensagem }}</p>
          </div>
          <div class="col-md-2" v-if="state.tipo == 'CURRICULO'">
            <div class="div_pdf">
              <label>Baixar Currículo</label>
              <p>
                <a target="blank" title="PDF" :href="state.curriculo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-filetype-pdf"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
                    />
                  </svg>
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="btns_right">
          <router-link to="/admin/contatos">
            <button type="button" class="btn_cancel">Voltar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      tipo: "",
      nome: "",
      email: "",
      razao_social: "",
      telefone: "",
      whatsapp: "",
      cidade: "",
      estado: "",
      mensagem: "",
      curriculo: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchContatos();
      }
    });
    async function fetchContatos() {
      try {
        const { data } = await services.contato.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome;
        state.email = data.email;
        state.tipo = data.tipo;
        state.razao_social = data.razao_social;
        state.telefone = data.telefone;
        state.whatsapp = data.whatsapp;
        state.cidade = data.cidade;
        state.estado = data.estado;
        state.mensagem = data.mensagem;
        state.curriculo = data.curriculo;
      } catch (error) {
        console.log(error);
      }
    }
    return {
      router,
      state,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #000;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
label {
  color: gray;
  font-size: 14pt;
  font-weight: 900;
  margin-bottom: 0;
  border-bottom: 2px solid gray;
  text-align: left;
}
p {
  color: #000;
  font-size: 12pt;
  font-weight: 700;
}
.btns_right {
  text-align: right;
  margin-top: 5rem;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.div_pdf {
  margin-top: 2rem;
  text-align: center;
}
svg {
  margin-top: 1rem;
  width: 50px;
  height: 50px;
  color: #000;
  transition: 0.2s;
}
svg:hover {
  color: blue;
}
</style>